import React from 'react'
import LatinoTemplateDefault from 'src/components/template/la/'
import { videos } from 'src/constants/videos'
export default (props) => {
  return (
    <LatinoTemplateDefault
      location={props.location}
      lang="es"
      market="latino"
      ctaText="Acceder Ahora"
      video={videos.liga_mx.videoUrl}
      staticAnnotation={videos.liga_mx.staticAnnotation}
      title="Ve la Liga MX en vivo en ESPN Deportes"
      subtitle="Accede desde tu smartphone, TV, computadora, o desde cualquier otro dispositivo"
      networkSet="soccerLatino"
      customNetworks={['espndeportes']}
      noteLink="/la/liga-mx-on-espn-deportes/"
      disableLAPlanCards={true}
    />
  )
}
